import utiles from "@/modules/Shared/utiles/utiles";
import store from "@/store";
import axios from "axios";

export default class DestinoService {
    constructor() {
        this.axios = axios.create(
            {
                baseURL: utiles.state.api,
                headers: {
                    Accept: "application/json",
                    'Content-Type': "application/json",
                    Authorization: "Bearer " + store.state.user.token
                }
            }
        );

        store.watch(
            (state) => state.user,
            (newUser) => {
              this.axios.defaults.headers.Authorization = `Bearer ${newUser.token}`;
            }
          );
    }

    async getAll() {
        const response = await this.axios.get('/destino');
        return response.data;
    }

    async create(data){
        const response = await this.axios.post('/destino', data)
        return response.data
    }

    async update(data)
    {
        const response = await this.axios.put('/destino', data)
        return response.data
    }

    async delete(id)
    {
        const response = await this.axios.delete('/destino?id=' + id)
        return response.data
    }
}
